import { render, staticRenderFns } from "./OrgsListFilters.vue?vue&type=template&id=5e85b6ac&"
import script from "./OrgsListFilters.vue?vue&type=script&lang=js&"
export * from "./OrgsListFilters.vue?vue&type=script&lang=js&"
import style0 from "./OrgsListFilters.vue?vue&type=style&index=0&id=5e85b6ac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports